import React from 'react';
import classnames from 'classnames';
import Selectable from 'buyside/components/presentation/Selectable/selectable';
import { SelectableTypes, SelectableColors } from 'interfaces/selectable/selectable';

import styles from './selectableDropdownStyles.scss';

export interface SelectableDropdownProps {
  analyticsTag?: string;
  children?: React.ReactNode;
  color?: SelectableColors;
  disabled?: boolean;
  isDarkTheme?: boolean;
  joyrideTarget?: string;
  title: string;
  overflowVisible?: boolean;
}

class SelectableDropdown extends React.Component<SelectableDropdownProps, { showing: boolean }> {
  private selectableDropdown: React.RefObject<HTMLDivElement>;

  constructor(props: SelectableDropdownProps) {
    super(props);
    this.state = { showing: false };
    this.toggleShowing = this.toggleShowing.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.selectableDropdown = React.createRef();
  }

  componentDidMount(): void {
    document.addEventListener('click', this.handleDocumentClick, false);
    document.addEventListener('touchend', this.handleDocumentClick, false);
  }

  componentWillUnmount(): void {
    document.removeEventListener('click', this.handleDocumentClick, false);
    document.removeEventListener('touchend', this.handleDocumentClick, false);
  }

  handleDocumentClick(e: Event): void {
    const target = e.target as Node;

    if (
      this.selectableDropdown.current &&
      !this.selectableDropdown.current.contains(target) &&
      !document.getElementById('modal_saved_search')?.contains(target)
    ) {
      if (this.state.showing) {
        this.setState({ showing: false });
      }
    }
  }

  toggleShowing(): void {
    this.setState(({ showing }): { showing: boolean } => ({ showing: !showing }));
  }

  render(): React.ReactElement {
    const {
      title,
      children,
      analyticsTag = null,
      disabled,
      color,
      isDarkTheme,
      joyrideTarget,
      overflowVisible = false
    } = this.props;
    const { showing } = this.state;

    return (
      <div className={styles.container} ref={this.selectableDropdown}>
        <Selectable
          id={`selectable-dropdown-${title}`}
          data-testid={`selectable-dropdown-${title}`}
          onClick={this.toggleShowing}
          type={SelectableTypes.CHECKBOX}
          checked={showing}
          data-heap={analyticsTag}
          disabled={disabled}
          isDarkTheme={isDarkTheme}
          readOnly
          color={color}
          joyrideTarget={joyrideTarget}
        >
          <div className={styles.centerText}>{title}</div>
        </Selectable>
        {showing ? (
          <div
            className={classnames(styles.content, { [styles.overflowVisible]: overflowVisible })}
          >
            {children}
          </div>
        ) : null}
      </div>
    );
  }
}

export default SelectableDropdown;
